import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import { PageResult } from '../../models/CoreModels';
import { CacheRequestState } from '../../models/RequestState';
import Pagination, { OnChangePageCallback } from '../misc/Pagination';
import * as Helper from '../../util/Helper';
import { useTranslation } from 'react-i18next';

interface FilterBottomComponentProps<T> {
    updateFilter: OnChangePageCallback
    requestState?: CacheRequestState<PageResult<T>>
    clearFilter?: React.MouseEventHandler<HTMLButtonElement>
}

const FilterBottomComponent = <T,>(props: FilterBottomComponentProps<T>) => {
    const { t } = useTranslation('common');
    const totalCount = Helper.getTotalCount(props.requestState);

    return (
        <div className="filter-bottom">
            <Row>
                <Col sm="3" className="vertical-center">
                    {totalCount !== undefined && <p className="small-italic">{(t('filterBottom.total', { ns: 'common' }))} {totalCount} {(t('filterBottom.result', { ns: 'common' }))}</p>}
                </Col>
                <Col sm="6">
                    <Pagination
                        requestState={props.requestState}
                        onChangePage={(p) => props.updateFilter(p)} />
                </Col>
                <Col sm="3">
                    <Button onClick={props.clearFilter}>{(t('filterBottom.resetFilter', { ns: 'common' }))}</Button>
                </Col>
            </Row>
        </div>
    )
}

export default FilterBottomComponent;
